import StockView from './StockView';
import { useTranslation } from 'react-i18next';
import StockHistory from './StockHistory';
import URLTabs from '../common/URLTabs';

export default function StockTabsView() {
  const { t } = useTranslation();

  return (
    <URLTabs
      size='large'
      defaultActiveKey='#stock'
      items={[
        {
          key: "#stock", 
          label: <span>{t("stock")}</span>, 
          children: <StockView/>
        },
        {
          key: "#history", 
          label: <span>{t("history")}</span>,
          children: <StockHistory/> 
        },
      ]}
    /> 
  )
}
